export const applyBgColor = (color: string, isDark: boolean) => {
  if (color === 'white') return 'bg-neutral-1';

  return isDark ? 'bg-blue-301' : 'bg-blue-21';
};

export const applyTitleColor = (backgroundColor: string, isDark: boolean) => {
  if (backgroundColor === 'blue' && isDark) {
    return 'text-neutral-1';
  }

  return 'text-neutral-301';
};
